import { render, staticRenderFns } from "./ProjectConfigurationDetails.vue?vue&type=template&id=54636a5c&scoped=true&"
import script from "./ProjectConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationDetails.vue?vue&type=style&index=0&id=54636a5c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54636a5c",
  null
  
)

export default component.exports